export const formatBytes = (bytes: number, decimals: number = 0): string => {
  if (bytes === 0) return "0 Bytes";

  const k: number = 1024;
  const sizes: string[] = [
    " Bytes",
    "Kb",
    "Mb",
    "Gb",
    "Tb",
    "Pb",
    "Eb",
    "Zb",
    "Yb",
  ];

  const i: number = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / k ** i).toFixed(decimals)}${sizes[i]}`;
};
